import React, { useState, useEffect } from "react";
import ChatSessionService from "services/chat-session.service";
import AuthService from "services/auth.service";
import Alert from "react-bootstrap/Alert";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function DoctorNotes(data) {
  const [showAlert, setShowAlert] = useState(false);
  const [note, setNote] = useState(data.chat.doctor_note || "");
  const save = () => {
    let params = {
      doctor_note: note,
    };
    ChatSessionService.update(data.chat.id, params).then(
      (data) => {
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };

  const QuillModules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
    ],
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (note && note !== data.chat.doctor_note) {
        save();
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [note]);

  return (
    <div className="doctor-notes">
      <div className="section-title">DOCTOR'S NOTE</div>
      <ReactQuill
        theme="snow"
        value={note}
        onChange={setNote}
        modules={QuillModules}
      />
      <div className="d-flex py-3 justify-content-end align-items-center">
        {data.chat.is_nutrition_session && (
          <span className="ai-personalised-note">
            Doctor's note updates will reflect in the next AI-generated meal
            comment.
          </span>
        )}
        <button
          className={
            "btn btn-link note-save-btn" +
            (note.replace(/<\/?[^>]+(>|$)/g, "").trim() === ""
              ? " disabled"
              : "")
          }
          type="submit"
          onClick={save}
        >
          Save
        </button>
      </div>

      <Alert
        className={`note-autosave ${showAlert ? "d-block" : "d-none"}`}
        key={"success"}
        variant={"success"}
        onClose={() => setShowAlert(false)}
        dismissible
      >
        Note saved.
      </Alert>
    </div>
  );
}

export default DoctorNotes;
